<ng-container *ngIf="identifier$ | async">
  <ng-container *ngIf="carouselContents?.length > 0">
    <div class="swiper-banner" [ngClass]="cssClasses(contentlet)">
      <ng-container *ngIf="!contentlet.maxWidth">
        <div class="left-over-flow-wrapper"></div>
        <div class="right-over-flow-wrapper"></div>
      </ng-container>
      <div
        [ngClass]="{
          'animate-navigations': contentlet.animateNavigation,
          'animate-pagination': contentlet.animatePagination,
          'swiper-slides-padding': contentlet.enableSpace,
          'color-navigation-layout-one': contentlet.navLayout == 1,
          'color-navigation-layout-two': contentlet.navLayout == 2,
          'center-vertically': contentlet.verticalCenter,
        }"
      >
        <swiper [config]="swiperConfig">
          <ng-template *ngFor="let content of carouselContents" swiperSlide>
            <custom-dot-cms-content-render [contentlet]="content"></custom-dot-cms-content-render>
          </ng-template>
        </swiper>
      </div>
    </div>
  </ng-container>
</ng-container>
